import { StudentTerminationStatus } from './../model/student-termination-status.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { Student } from 'src/app/model/student/student.model';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class StudentTerminationsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    getStudentTerminationStatusHistory(studentId: number): Observable<any> {
        return this.get<any>(EndPoints.studentTerminations_GetStudentTerminationStatusHistory, '', studentId);
    }

    getStudentTerminationStatusTypes(): Observable<any> {
        return this.get<any>(EndPoints.studentTerminations_GetStudentTerminationStatusTypes, '');
    }

    getSchoolEnrollments(studentId: number): Observable<any> {
        return this.get<any>(EndPoints.studentTerminations_GetSchoolEnrollments, '', studentId);
    }

    create(student: Student): Observable<any> {
        return this.post<any>(EndPoints.studentTerminations_Create, false, null, {
            student: student
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    deleteStudentTerminations(deleteStudentTerminations: StudentTerminationStatus[]): Observable<any> {
        return this.post<any>(EndPoints.studentTerminations_Delete, false, null, {
            deleteStudentTerminations: deleteStudentTerminations
        }).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }

    getGroupCurrentStudentTerminationStatuses(requestPayload: any): Observable<any> {
        return this.post<any>(EndPoints.student_GetGroupCurrentStudentTerminationStatuses, false, '', requestPayload).pipe(
            switchMap((result) => {
                return of(result);
            }),
            catchError((err) => {
                return throwError(() => new Error(err));
            })
        );
    }
}
